import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", null, "提醒您：尚未啟用 Messenger 通知，請儘速點選以下按鈕啟用", -1 /* HOISTED */)
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", { viewBox: "0 0 40 40" }, [
  /*#__PURE__*/_createVNode("g", { fill: "#FFFFFF" }, [
    /*#__PURE__*/_createVNode("path", { d: "M20,0 C31.2666,0 40,8.2528 40,19.4 C40,30.5472 31.2666,38.8 20,38.8 C17.9763,38.8 16.0348,38.5327 14.2106,38.0311 C13.856,37.9335 13.4789,37.9612 13.1424,38.1098 L9.1727,39.8621 C8.1343,40.3205 6.9621,39.5819 6.9273,38.4474 L6.8184,34.8894 C6.805,34.4513 6.6078,34.0414 6.2811,33.7492 C2.3896,30.2691 0,25.2307 0,19.4 C0,8.2528 8.7334,0 20,0 Z M7.99009,25.07344 C7.42629,25.96794 8.52579,26.97594 9.36809,26.33674 L15.67879,21.54734 C16.10569,21.22334 16.69559,21.22164 17.12429,21.54314 L21.79709,25.04774 C23.19919,26.09944 25.20039,25.73014 26.13499,24.24744 L32.00999,14.92654 C32.57369,14.03204 31.47419,13.02404 30.63189,13.66324 L24.32119,18.45264 C23.89429,18.77664 23.30439,18.77834 22.87569,18.45674 L18.20299,14.95224 C16.80079,13.90064 14.79959,14.26984 13.86509,15.75264 L7.99009,25.07344 Z" })
  ])
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "點我啟用 Messenger 通知", -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createVNode("p", null, "若要檢查設定結果，請點選以下按鈕", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", { viewBox: "0 0 512 512" }, [
  /*#__PURE__*/_createVNode("g", { fill: "#ffffff" }, [
    /*#__PURE__*/_createVNode("path", { d: "M493.815,70.629c-11.001-1.003-20.73,7.102-21.733,18.102l-2.65,29.069C424.473,47.194,346.429,0,256,0\n\t\t\t\t\t\tC158.719,0,72.988,55.522,30.43,138.854c-5.024,9.837-1.122,21.884,8.715,26.908c9.839,5.024,21.884,1.123,26.908-8.715\n\t\t\t\t\t\tC102.07,86.523,174.397,40,256,40c74.377,0,141.499,38.731,179.953,99.408l-28.517-20.367c-8.989-6.419-21.48-4.337-27.899,4.651\n\t\t\t\t\t\tc-6.419,8.989-4.337,21.479,4.651,27.899l86.475,61.761c12.674,9.035,30.155,0.764,31.541-14.459l9.711-106.53\n\t\t\t\t\t\tC512.919,81.362,504.815,71.632,493.815,70.629z" })
  ]),
  /*#__PURE__*/_createVNode("g", { fill: "#ffffff" }, [
    /*#__PURE__*/_createVNode("path", { d: "M472.855,346.238c-9.838-5.023-21.884-1.122-26.908,8.715C409.93,425.477,337.603,472,256,472\n\t\t\t\t\t\tc-74.377,0-141.499-38.731-179.953-99.408l28.517,20.367c8.989,6.419,21.479,4.337,27.899-4.651\n\t\t\t\t\t\tc6.419-8.989,4.337-21.479-4.651-27.899l-86.475-61.761c-12.519-8.944-30.141-0.921-31.541,14.459l-9.711,106.53\n\t\t\t\t\t\tc-1.003,11,7.102,20.73,18.101,21.733c11.014,1.001,20.731-7.112,21.733-18.102l2.65-29.069C87.527,464.806,165.571,512,256,512\n\t\t\t\t\t\tc97.281,0,183.012-55.522,225.57-138.854C486.594,363.309,482.692,351.262,472.855,346.238z" })
  ])
], -1 /* HOISTED */)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "檢查 Messenger 通知設定結果", -1 /* HOISTED */)

import { computed, nextTick, ref, useCssModule } from 'vue'
import { useIdentity } from '@/composables/useIdentity'
import Card from '@/components/Card.vue'


export default _defineComponent({
  expose: [],
  setup(__props) {

const appConfig = app_config
const identity = useIdentity()
const style = useCssModule()
const sendTo = `http://m.me/${app_config.pageId}?ref=${identity.id}`
const showRefresh = ref(false)

const clickSendTo = (e : MouseEvent) => {
	logger('info', 3, identity.name, identity.id, app_config.pageId)

	showRefresh.value = true
}

const refreshStatus = () => {
	window.location.reload()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_unref(identity).hasPSID && !showRefresh.value)
      ? (_openBlock(), _createBlock(Card, {
          key: 0,
          title: "⚠️ 粉絲團需啟用 Messenger 通知⚠️",
          titleColor: "#f27474"
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createVNode("a", {
              href: sendTo,
              target: "_blank",
              class: _unref(style).sendToMessenger,
              onClick: clickSendTo
            }, [
              _hoisted_2,
              _hoisted_3
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (showRefresh.value)
      ? (_openBlock(), _createBlock(Card, {
          key: 1,
          title: "⚙️ Messenger 通知設定中 ⚙️",
          titleColor: "#f27474"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createVNode("a", {
              href: "#",
              class: _unref(style).refreshStatus,
              onClick: refreshStatus
            }, [
              _hoisted_5,
              _hoisted_6
            ], 2 /* CLASS */)
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true),
    (_unref(identity).hasPSID)
      ? (_openBlock(), _createBlock(Card, {
          key: 2,
          title: "⚡ 成功設定 Messenger 通知 ⚡",
          titleColor: "#388e3c",
          hideContent: true
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})